export interface Styleguide {
  id: number;
  name: string;
  team_id: number;
  project_id?: number;
  share_id: string;
}

export interface TreeNode {
  id: number;
  type: string;
  name: string;
  hidden: boolean;
  children: NodeType[];
}

export interface CategoryNode extends TreeNode {
  type: "category";
}

export interface PageNode extends TreeNode {
  type: "page";
  url: string;
  category_overview_page: boolean;
}

export interface NavigationNode extends TreeNode {
  type: "navigation";
}

export interface TabNode extends TreeNode {
  type: "tab";
  url: string;
}

export type NodeType = CategoryNode | PageNode | NavigationNode | TabNode;

export interface StyleguideVersion {
  id: number;
  name: string;
  default: boolean;
  working_version: boolean;
  created_at: string;
  release_notes: string | null;
}
